<template>
    <v-dialog
        :value="value"
        persistent
        no-click-animation
        max-width="536"
        content-class="max-risk-dialog-wrap"
        overlay-color="#1A1A2E"
        overlay-opacity="0.5"
        @keydown.esc.prevent.stop
    >
        <div
            :id="dialogId"
            class="max-risk-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="max-risk-dialog-title"
            aria-describedby="max-risk-dialog-description"
            @click.stop
            @keydown.esc.prevent.stop
        >
            <div class="max-risk-dialog__body">
                <div class="max-risk-dialog__title-line">
                    <span class="max-risk-dialog__logo" aria-hidden="true">
                        <img :src="maxLogo" alt="" />
                    </span>
                    <h3 id="max-risk-dialog-title" class="max-risk-dialog__title">Учитывайте риск блокировки</h3>
                </div>
                <div class="max-risk-dialog__risk">
                    <p id="max-risk-dialog-description" class="max-risk-dialog__copy">
                        Мы не рекомендуем канал MAX для маркетинговых рассылок в связи с повышенным риском блокировки.
                    </p>
                </div>
                <div class="max-risk-dialog__actions">
                    <button
                        ref="primaryBtn"
                        type="button"
                        class="max-risk-dialog__btn max-risk-dialog__btn--primary"
                        @click="$emit('remove')"
                    >
                        Убрать MAX из рассылок
                    </button>
                    <button type="button" class="max-risk-dialog__btn max-risk-dialog__btn--secondary" @click="$emit('accept')">
                        Понимаю риски
                    </button>
                </div>
                <p class="max-risk-dialog__note">
                    Будет изменён приоритет только в выбранной колонке.
                    <b v-if="context">{{ context }}</b>
                </p>
            </div>
        </div>
    </v-dialog>
</template>

<script>
const maxLogo = require('@/assets/img/messenger-logo/max-logo.png')

export default {
    name: 'MaxMarketingRiskModal',
    data: () => ({
        maxLogo,
        dialogId: `max-risk-dialog-${Math.random().toString(36).slice(2, 10)}`,
    }),
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        context: {
            type: String,
            default: '',
        },
    },
    watch: {
        value(isOpen) {
            if (isOpen) {
                this.addOutsideCloseListeners()
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        this.elevateDialog()
                        this.$refs.primaryBtn?.focus?.()
                    })
                })
                window.setTimeout(() => this.elevateDialog(), 50)
                return
            }
            this.removeOutsideCloseListeners()
        },
    },
    mounted() {
        if (this.value) this.addOutsideCloseListeners()
    },
    beforeDestroy() {
        this.removeOutsideCloseListeners()
    },
    methods: {
        addOutsideCloseListeners() {
            document.addEventListener('mousedown', this.onDocumentPointerDown, true)
            document.addEventListener('touchstart', this.onDocumentPointerDown, true)
        },
        removeOutsideCloseListeners() {
            document.removeEventListener('mousedown', this.onDocumentPointerDown, true)
            document.removeEventListener('touchstart', this.onDocumentPointerDown, true)
        },
        elevateDialog() {
            const card = document.getElementById(this.dialogId)
            const content = card?.closest('.v-dialog__content')
            if (!content) return
            const current = Number(content.style.zIndex || 0)
            const target = 1400
            if (current >= target) return
            document.querySelectorAll('.v-overlay--active').forEach(el => {
                const zIndex = Number(el.style.zIndex || 0)
                if (zIndex === current - 1) {
                    el.style.zIndex = String(target - 1)
                }
            })
            content.style.zIndex = String(target)
        },
        onDocumentPointerDown(event) {
            if (!this.value) return
            const modalElement = document.getElementById(this.dialogId)
            if (!modalElement) return
            const path = typeof event.composedPath === 'function' ? event.composedPath() : []
            const target = event.target
            const clickedInside = path.includes(modalElement) || (target instanceof Node && modalElement.contains(target))
            if (!clickedInside) this.$emit('dismiss')
        },
    },
}
</script>

<style>
.v-dialog.max-risk-dialog-wrap {
    margin: 16px !important;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    overflow: visible !important;
    width: min(536px, calc(100vw - 32px)) !important;
    max-width: calc(100vw - 32px) !important;
    max-height: none !important;
}

.v-application .max-risk-dialog,
.v-application .max-risk-dialog * {
    box-sizing: border-box;
}

.v-application .max-risk-dialog {
    width: 100%;
    max-height: calc(100dvh - 32px);
    overflow: auto;
    scrollbar-width: thin;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 24px 72px rgba(19, 23, 61, 0.24);
    color: #1a1a2e;
    font-family: Geologica, system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    text-align: left;
}

.v-application .max-risk-dialog__body {
    padding: 32px;
}

.v-application .max-risk-dialog__title-line {
    display: flex;
    gap: 16px;
    align-items: center;
}

.v-application .max-risk-dialog__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    flex: none;
    overflow: hidden;
    border-radius: 10px;
    background: #2492f4;
}

.v-application .max-risk-dialog__logo img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: none !important;
    object-fit: cover;
    border-radius: 10px;
}

.v-application .max-risk-dialog__title {
    margin: 0 !important;
    padding: 0 !important;
    color: #1a1a2e !important;
    font-family: Geologica, system-ui, sans-serif !important;
    font-size: 26px !important;
    font-weight: 650 !important;
    line-height: 1.23 !important;
    letter-spacing: -0.025em !important;
    text-transform: none !important;
    text-wrap: balance;
}

.v-application .max-risk-dialog__risk {
    margin: 24px 0;
    padding: 16px;
    background: #fff4d9;
    border: 1px solid #f4c96f;
    border-radius: 12px;
}

.v-application .max-risk-dialog__copy,
.v-application .max-risk-dialog__note {
    margin: 0 !important;
    padding: 0 !important;
    font-family: Geologica, system-ui, sans-serif !important;
    text-transform: none !important;
}

.v-application .max-risk-dialog__copy {
    color: #1a1a2e !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 1.6 !important;
}

.v-application .max-risk-dialog__actions {
    display: flex;
    gap: 12px;
    margin-top: 24px;
}

.v-application .max-risk-dialog__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 48px !important;
    min-width: 0 !important;
    height: auto !important;
    margin: 0 !important;
    padding: 12px 16px !important;
    border-radius: 12px !important;
    border-style: solid !important;
    border-width: 1px !important;
    font-family: Geologica, system-ui, sans-serif !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    line-height: 1.5 !important;
    letter-spacing: normal !important;
    text-transform: none !important;
    text-decoration: none !important;
    white-space: nowrap;
    cursor: pointer;
    appearance: none;
    box-shadow: none !important;
    transition: background-color 0.12s, border-color 0.12s, box-shadow 0.12s;
}

.v-application .max-risk-dialog__btn:focus {
    outline: none;
}

.v-application .max-risk-dialog__btn:focus-visible {
    outline: 3px solid #525ad5 !important;
    outline-offset: 3px;
}

.v-application .max-risk-dialog__btn--primary {
    flex: 1 1 auto;
    background: #525ad5 !important;
    color: #fff !important;
    border-color: transparent !important;
}

.v-application .max-risk-dialog__btn--primary:hover {
    background: #4249b8 !important;
}

.v-application .max-risk-dialog__btn--primary:active {
    background: #343b9f !important;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.v-application .max-risk-dialog__btn--secondary {
    flex: 0 0 auto;
    background: #fff !important;
    color: #525ad5 !important;
    border-color: #ccd0f4 !important;
}

.v-application .max-risk-dialog__btn--secondary:hover {
    background: #eef0ff !important;
    border-color: #525ad5 !important;
}

.v-application .max-risk-dialog__btn--secondary:active {
    background: #e3e6ff !important;
}

.v-application .max-risk-dialog__note {
    margin-top: 16px !important;
    color: #646b7e !important;
    font-size: 11px !important;
    font-weight: 400 !important;
    line-height: 1.55 !important;
}

.v-application .max-risk-dialog__note b {
    display: block;
    margin-top: 4px;
    color: #1a1a2e !important;
    font-weight: 500 !important;
}

@media (max-width: 600px) {
    .v-application .max-risk-dialog {
        border-radius: 20px;
    }

    .v-application .max-risk-dialog__body {
        padding: 24px;
    }

    .v-application .max-risk-dialog__title {
        font-size: 23px !important;
        line-height: 1.3 !important;
    }

    .v-application .max-risk-dialog__actions {
        flex-direction: column;
        gap: 8px;
    }

    .v-application .max-risk-dialog__btn {
        width: 100% !important;
        flex: none !important;
        white-space: normal;
    }
}
</style>
